import React, { PureComponent } from 'react'
import { ReactComponent as CheckIcon } from '../../../assets/images/icons/i-check-20-20.svg'

import './CheckText.scss'

interface CheckTextProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: string
}

class CheckText extends PureComponent<CheckTextProps> {
  render() {
    const {
      children,
    } = this.props

    return (
      <span className="check-text">
        <span className="check-text__icon"><CheckIcon /></span>
        {children}
      </span>
    )
  }
}

export default CheckText
